import $ from 'jquery';

class Cart{

    constructor(){

        this.addCartPreviewHTML();

        this.isPreviewOpen = false;

        this.openButton = $("#cart-preview-button");

        this.cartPreview = $(".cart-preview");
        
        this.cartPreviewOverlay = $(".cart-preview-overlay");
        
        this.events();

    }

    events(){

        this.openButton.on("click", ()=>{

            if(this.isPreviewOpen){
                
                this.hideCartPreview();
                
            } else {
                this.openCartPreview();
            }
        });

        this.cartPreviewOverlay.on("click", ()=>{   
            
            this.hideCartPreview();
            
        });

        $(document).on("keydown", (event)=> this.keyPressDispatcher(event) );
        
    }

    keyPressDispatcher(event){

        if(event.keyCode == 67 && !this.isPreviewOpen && !$("input, textarea").is(':focus')){

            this.openCartPreview();

        }

        if(event.keyCode == 27 && this.isPreviewOpen ){

            this.hideCartPreview();

        }
        
    }

    openCartPreview(){

        this.showCartPreview();
        
    }
    hideCartPreview(){

        this.isPreviewOpen = false;

        $(this.cartPreview).removeClass("show-cart-preview");

        $(this.cartPreviewOverlay).removeClass("show-cart-preview-overlay"); 
    }

    showCartPreview(){

        this.isPreviewOpen = true;

        $(this.cartPreview).addClass("show-cart-preview");

        $(this.cartPreviewOverlay).addClass("show-cart-preview-overlay");

    }

    addCartPreviewHTML(){
       
        $("body").append(`

            <div class="cart-preview-overlay"></div>
            
            <div class="cart-preview">

                <div class="cart-preview__header">
                    <h2>Subtotal</h2>
                    <span id="cart-preview-total">$0.00</span>
                    <a href="/cart/">Go to Cart</a>                    
                </div>
            
                <div class="cart-preview__body">
                    <p class="cart-preview__empty-text">Your cart is currently empty</p>
                </div>
            
            </div>           
            
        `);

    }

}

export default Cart;